const MooringReviewStatus = {
  Waiting: 1,
  Rejected: 2,
  Aborted: 3,
  Approved: 4,
};

export const mooringReviewStatusToText: {
  [key in MooringReviewStatus]: string;
} = {
  [MooringReviewStatus.Waiting]: 'mooring.status.waiting',
  [MooringReviewStatus.Rejected]: 'mooring.status.requiresCorrection',
  [MooringReviewStatus.Aborted]: 'mooring.status.aborted',
  [MooringReviewStatus.Approved]: 'mooring.status.approved',
};

type MooringReviewStatus = (typeof MooringReviewStatus)[keyof typeof MooringReviewStatus];

class BaseMooringReviewDto {
  ReviewId: number;

  CreatedBy: string;
  CreatedById: string;

  Created: Date;
  Updated: Date;

  ReviewedBy?: string;
  ReviewedById?: string;

  AnchorLinesReviewedAt: Date;
  AnchorLinesReviewedBy: string;

  GridLinesReviewedAt: Date;
  GridLinesReviewedBy: string;

  BuoysReviewedAt: Date;
  BuoysReviewedBy: string;

  CagesReviewedAt: Date;
  CagesReviewedBy: string;

  BridlesReviewedAt: Date;
  BridlesReviewedBy: string;

  FleetAnchorLinesReviewedAt: Date;
  FleetAnchorLinesReviewedBy: string;

  Status: MooringReviewStatus;
}

export class MooringReviewListItemDto extends BaseMooringReviewDto {
  Comments: number;
}

export class MooringReviewDto extends BaseMooringReviewDto {
  Comment?: string;
  MapOrientationChecked: boolean;
  CanCompleteReview: boolean;

  AllAnchoringComponentsReviewed: boolean;
  AllFleetComponentsReviewed: boolean;
}

export class UpdateReviewDto {
  MapOrientationChecked: boolean;
  Comment: string;
}

export class AbortReviewDto {
  Comment: string;
}

export class CompleteReviewDto {
  Comment: string;
  Approve: boolean;
}

export type MooringOfferReviewStep = 'ANCHORLINES' | 'GRIDLINES' | 'BUOYS' | 'CAGES' | 'BRIDLES' | 'FLEETANCHORLINES';

export class UpdateMooringOfferReviewStepDto {
  Step: MooringOfferReviewStep;
  Reviewed: boolean;
}
